"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationEntry3ToJSON = exports.NavigationEntry3FromJSONTyped = exports.NavigationEntry3FromJSON = void 0;
function NavigationEntry3FromJSON(json) {
    return NavigationEntry3FromJSONTyped(json, false);
}
exports.NavigationEntry3FromJSON = NavigationEntry3FromJSON;
function NavigationEntry3FromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.NavigationEntry3FromJSONTyped = NavigationEntry3FromJSONTyped;
function NavigationEntry3ToJSON(value) {
    return value;
}
exports.NavigationEntry3ToJSON = NavigationEntry3ToJSON;
//# sourceMappingURL=NavigationEntry3.js.map